import { render, staticRenderFns } from "./SRTitleListGraphql.vue?vue&type=template&id=50b30b7b&scoped=true"
import script from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRTitleListGraphql.vue?vue&type=style&index=0&id=50b30b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b30b7b",
  null
  
)

export default component.exports